var _style, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 389 109",
    style: {
      enableBackground: "new 0 0 389 109"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#XMLID_55_);} .st1{fill:#00000;} ")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5311,
    y1: 19.9436,
    x2: 46.9761,
    y2: 19.9436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1318,
    style: {
      stopColor: "#37B559"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4158,
    style: {
      stopColor: "#29B789"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8266,
    style: {
      stopColor: "#00BCD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00BFF3"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_278_",
    className: "st0",
    points: "47,25.4 33.7,13.6 33.7,13.6 26.3,6.9 26.3,7 26.2,6.9 18.6,13.8 18.6,13.8 5.5,25.4 12.2,33 26.1,20.4 40.3,33 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    className: "st1",
    d: "M20.4,83.4v-46h11.8v46H20.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    className: "st1",
    d: "M90.2,83.4H78.4V57.9c0-3.6-0.6-6.3-1.9-8c-1.3-1.7-3.1-2.5-5.4-2.5c-1.6,0-3.2,0.4-4.8,1.2 c-1.6,0.8-3.1,1.9-4.3,3.3c-1.3,1.4-2.2,3-2.8,4.8v26.6H47.4V37.8H58v8.5c1.2-2,2.7-3.6,4.5-5c1.8-1.4,3.9-2.4,6.3-3.1 c2.4-0.7,4.9-1.1,7.5-1.1c2.9,0,5.2,0.5,7.1,1.5c1.8,1,3.3,2.4,4.2,4.1c1,1.7,1.6,3.6,2,5.8c0.4,2.1,0.6,4.3,0.6,6.5V83.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    className: "st1",
    d: "M117.4,84.2c-3.9,0-7.7-0.6-11.2-1.9c-3.6-1.3-6.6-3.2-9.2-5.7l4.2-7.6 c2.8,2.2,5.5,3.9,8.1,4.9c2.7,1.1,5.2,1.6,7.7,1.6c2.3,0,4.1-0.4,5.5-1.2c1.4-0.8,2.1-2,2.1-3.6c0-1.1-0.4-2-1.1-2.6 c-0.8-0.6-1.9-1.1-3.3-1.6c-1.4-0.5-3.2-1-5.2-1.6c-3.4-1.1-6.2-2.2-8.5-3.2c-2.3-1-4-2.4-5.1-3.9c-1.1-1.6-1.7-3.6-1.7-6.1 c0-3,0.8-5.6,2.3-7.8c1.6-2.2,3.7-3.9,6.5-5.1c2.8-1.2,6-1.8,9.8-1.8c3.3,0,6.4,0.5,9.3,1.5c2.9,1,5.6,2.7,8,5l-4.7,7.5 c-2.3-1.8-4.6-3.1-6.7-4c-2.1-0.8-4.2-1.3-6.4-1.3c-1.2,0-2.4,0.1-3.5,0.4c-1.1,0.3-2,0.8-2.6,1.4c-0.7,0.7-1,1.6-1,2.8 c0,1.1,0.3,1.9,0.9,2.6c0.6,0.6,1.6,1.1,2.8,1.6c1.3,0.5,2.8,1,4.6,1.6c3.7,1,6.8,2.1,9.4,3.2c2.5,1.1,4.5,2.4,5.8,4 c1.3,1.6,1.9,3.8,1.9,6.5c0,4.5-1.7,8-5,10.5C127.5,83,123,84.2,117.4,84.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_269_",
    className: "st1",
    d: "M171.4,84.2c-3.6,0-6.7-0.8-9.4-2.4c-2.7-1.6-4.8-3.7-6.4-6.5v26.7h-11.8V37.8h10.3v7.9 c1.8-2.7,4-4.8,6.7-6.3c2.7-1.5,5.8-2.3,9.2-2.3c3.1,0,6,0.6,8.6,1.8c2.6,1.2,4.9,2.9,6.8,5.1c1.9,2.2,3.4,4.7,4.5,7.5 c1.1,2.8,1.6,5.8,1.6,9.1c0,4.4-0.9,8.4-2.6,12c-1.7,3.6-4.1,6.4-7.1,8.6C178.8,83.2,175.3,84.2,171.4,84.2z M167.5,74.2 c1.8,0,3.5-0.4,4.9-1.1c1.5-0.7,2.7-1.8,3.8-3.1c1.1-1.3,1.9-2.8,2.5-4.4c0.6-1.6,0.8-3.3,0.8-5.1c0-1.9-0.3-3.6-0.9-5.3 c-0.6-1.6-1.5-3-2.7-4.3s-2.5-2.2-4.1-2.9c-1.6-0.7-3.2-1-5.1-1c-1.1,0-2.2,0.2-3.4,0.6c-1.1,0.4-2.2,0.9-3.3,1.6 c-1.1,0.7-2,1.5-2.8,2.4c-0.8,0.9-1.4,1.9-1.7,3v10.7c0.7,1.7,1.7,3.2,2.9,4.5c1.2,1.4,2.6,2.4,4.2,3.2 C164.2,73.8,165.8,74.2,167.5,74.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_266_",
    className: "st1",
    d: "M220.9,84.2c-3.7,0-7-0.6-10-1.9c-3-1.2-5.5-3-7.6-5.1c-2.1-2.2-3.7-4.7-4.9-7.5 c-1.1-2.8-1.7-5.8-1.7-8.9c0-4.3,1-8.3,2.9-11.9c2-3.6,4.8-6.5,8.4-8.6c3.7-2.2,8-3.3,13-3.3c5,0,9.3,1.1,12.9,3.3 c3.6,2.2,6.3,5,8.2,8.6c1.9,3.6,2.9,7.4,2.9,11.5c0,0.7,0,1.4-0.1,2.1c-0.1,0.7-0.1,1.3-0.2,1.8h-35.6c0.2,2.3,0.9,4.3,2.1,6 c1.1,1.7,2.6,3,4.4,3.9c1.8,0.9,3.7,1.3,5.8,1.3c2.3,0,4.6-0.6,6.6-1.7s3.5-2.6,4.3-4.5l10.1,2.8c-1.1,2.3-2.7,4.4-4.8,6.2 c-2.1,1.8-4.5,3.2-7.3,4.3C227.4,83.7,224.3,84.2,220.9,84.2z M208.8,56.9h24.1c-0.2-2.3-0.9-4.3-2-6c-1.1-1.7-2.5-3-4.3-3.9 c-1.8-0.9-3.7-1.4-5.9-1.4c-2.1,0-4,0.5-5.8,1.4c-1.7,0.9-3.1,2.3-4.2,3.9C209.7,52.6,209.1,54.6,208.8,56.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_263_",
    className: "st1",
    d: "M273.5,84.2c-3.7,0-7-0.6-10-1.9c-3-1.2-5.5-3-7.6-5.1c-2.1-2.2-3.7-4.7-4.9-7.5 c-1.1-2.8-1.7-5.8-1.7-8.9c0-4.3,1-8.3,2.9-11.9c2-3.6,4.8-6.5,8.4-8.6c3.7-2.2,8-3.3,13-3.3c5,0,9.3,1.1,12.9,3.3 c3.6,2.2,6.3,5,8.2,8.6c1.9,3.6,2.9,7.4,2.9,11.5c0,0.7,0,1.4-0.1,2.1c-0.1,0.7-0.1,1.3-0.2,1.8h-35.6c0.2,2.3,0.9,4.3,2.1,6 c1.1,1.7,2.6,3,4.4,3.9c1.8,0.9,3.7,1.3,5.8,1.3c2.3,0,4.6-0.6,6.6-1.7s3.5-2.6,4.3-4.5l10.1,2.8c-1.1,2.3-2.7,4.4-4.8,6.2 c-2.1,1.8-4.5,3.2-7.3,4.3C280,83.7,276.9,84.2,273.5,84.2z M261.5,56.9h24.1c-0.2-2.3-0.9-4.3-2-6c-1.1-1.7-2.5-3-4.3-3.9 c-1.8-0.9-3.7-1.4-5.9-1.4c-2.1,0-4,0.5-5.8,1.4c-1.7,0.9-3.1,2.3-4.2,3.9C262.3,52.6,261.7,54.6,261.5,56.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_261_",
    className: "st1",
    d: "M332.2,47.5c-3.6,0-6.8,0.7-9.6,2.1c-2.8,1.4-4.8,3.4-6.1,5.9v27.8h-11.8V37.8h10.8v9.4 c1.6-3.2,3.7-5.7,6.2-7.5c2.5-1.8,5.2-2.8,8-3c0.6,0,1.1,0,1.5,0c0.4,0,0.6,0,0.9,0.1V47.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_258_",
    className: "st1",
    d: "M359.4,84.2c-3.7,0-7.1-0.6-10.1-1.9c-3-1.2-5.5-3-7.6-5.2c-2.1-2.2-3.7-4.7-4.8-7.6 c-1.1-2.8-1.7-5.8-1.7-8.9c0-3.2,0.6-6.2,1.7-9c1.1-2.8,2.7-5.4,4.8-7.6c2.1-2.2,4.6-3.9,7.6-5.2c3-1.2,6.4-1.9,10.1-1.9 c3.7,0,7.1,0.6,10.1,1.9c3,1.2,5.5,3,7.6,5.2c2.1,2.2,3.7,4.7,4.8,7.6c1.1,2.8,1.6,5.8,1.6,9c0,3.1-0.5,6.1-1.6,8.9 c-1.1,2.8-2.7,5.4-4.7,7.6c-2.1,2.2-4.6,3.9-7.6,5.2C366.5,83.6,363.1,84.2,359.4,84.2z M347.4,60.7c0,2.6,0.5,5,1.6,7 c1.1,2,2.5,3.6,4.3,4.8c1.8,1.1,3.9,1.7,6.1,1.7c2.2,0,4.2-0.6,6.1-1.8c1.8-1.2,3.3-2.8,4.3-4.8c1.1-2,1.6-4.4,1.6-7 c0-2.6-0.5-4.9-1.6-7c-1.1-2.1-2.5-3.7-4.3-4.8c-1.8-1.1-3.8-1.7-6.1-1.7c-2.3,0-4.3,0.6-6.1,1.8c-1.8,1.2-3.3,2.8-4.3,4.8 C347.9,55.7,347.4,58.1,347.4,60.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlBlack);
export default __webpack_public_path__ + "static/media/il-black.f2948ec4fa60f4698e2e3bd5f069d62d.svg";
export { ForwardRef as ReactComponent };